import api from '@pray/shared/utils/api';

import type { SeedResponse, SeedSourceValue } from './types';

const SEEDS_URL = '/web/studio/admin/seed-emails/seeds';

export type PatchSeedParams = {
  seedId: string;
  email?: string;
  source?: SeedSourceValue;
  /** Replaces the whole membership. Leave it out to keep the seed's groups as they are. */
  groupIds?: string[];
};

/**
 * Edits one seed and answers the row as it now stands.
 *
 * Only the fields the caller passes travel: the API tells an absent `group_ids` ("keep the
 * membership") from an empty one ("remove it from every group"), so sending `[]` for undefined
 * would silently empty the groups of a seed whose address was the only thing edited.
 */
export async function patchSeed({ seedId, email, source, groupIds }: PatchSeedParams) {
  const body: Record<string, unknown> = {};
  if (email !== undefined) body.email = email;
  if (source !== undefined) body.source = source;
  if (groupIds !== undefined) body.group_ids = groupIds;

  const res = await api.executePatchRequest<{ data: SeedResponse }>(`${SEEDS_URL}/${seedId}`, body);
  return res.data.data;
}
